import type { Messages } from "@/i18n/locales/en";
import { legalMessagesLv } from "@/i18n/locales/legalLvData";
import { pagesMessagesLv } from "@/i18n/locales/pagesLvData";

export const lvMessages = {
  meta: {
    description:
      "WasOK — skenējiet produktus, saglabājiet vērtējumus un piezīmes, atcerieties, ko bija vērts pirkt.",
    title: "WasOK — Atcerieties, ko bija vērts pirkt",
  },
  header: {
    navFeatures: "Iespējas",
    navHowItWorks: "Kā tas darbojas",
    navPrivacy: "Privātums",
    navUseCases: "Piemēri",
    download: "Lejupielādēt",
    openMenu: "Atvērt izvēlni",
    closeMenu: "Aizvērt izvēlni",
    languageAria: "Valoda",
  },
  hero: {
    badge: "📱 Pieejams Android ierīcēm",
    title: "Atcerieties, ko bija vērts pirkt.",
    subtitle:
      "Skenējiet produktus, saglabājiet vērtējumus un piezīmes un uzreiz atcerieties, vai produkts tiešām bija labs.",
    googlePlay: "Lejupielādēt Google Play",
    watchDemo: "Skatīties demo",
    privacyLine: "Visi dati paliek jūsu ierīcē.",
    phoneTitle: "WasOK",
    phoneSubtitle: "Skenējiet, lai atcerētos",
    snackCard: "Gardi!",
    coffeeCard: "Pārāk rūgts",
    scrollHint: "Ritiniet, lai izpētītu",
  },
  problems: {
    heading: "Pazīstami?",
    subheading:
      "Mēs visi tur bijuši — stāvam pie plaukta un cenšamies atcerēties, vai iepriekš patika.",
    notedAgo: "✓ Jūs pierakstījāt šo pirms 3 mēnešiem",
    items: [
      {
        question: "Kura šokolāde man tiešām garšoja?",
        note: "Ideāla saldums",
      },
      {
        question: "Kāpēc es pārtradu pirkt šo šampūnu?",
        note: "Izžāva matus",
      },
      {
        question: "Vai šī kafija bija laba vai vilinoša?",
        note: "Pārāk rūgta",
      },
    ],
  },
  howItWorks: {
    heading: "Kā tas darbojas",
    subheading:
      "Četri vienkārši soļi, lai neaizmirstu savu viedokli par produktiem.",
    stepPrefix: "Solis",
    steps: [
      {
        title: "Skenējiet jebkura produkta svītrkodu",
        description:
          "Ātri un viegli ar kameru. Der jebkuram svītrkodam.",
      },
      {
        title: "Saglabājiet vērtējumus, komentārus un foto",
        description:
          "Novērtējiet, pievienojiet piezīmes, foto, cenas un pirkuma vietas.",
      },
      {
        title: "Uzreiz atcerieties pieredzi",
        description:
          "Atkārtoti skenējot redzēsiet iepriekšējo vērtējumu un piezīmes.",
      },
      {
        title: "Veidojiet gudrus iepirkumu sarakstus",
        description:
          "Izveidojiet sarakstus no produktiem, kuriem jau uzticaties.",
      },
    ],
  },
  privacy: {
    heading: "Jūsu iepirkumu vēsture paliek jūsu.",
    body: "WasOK palīdz atcerēties produktus, ko esat izmēģinājuši, saglabājot vērtējumus, piezīmes, fotoattēlus un iepirkumu sarakstus lokāli jūsu ierīcē.",
    trustBanner:
      "💚 Veidots ap jūsu iepirkumu vēsturi — nevis ap jūsu datu vākšanu.",
    bullets: [
      "Konts nav nepieciešams",
      "Mākoņa sinhronizācija nav nepieciešama",
      "Lokāla datu glabāšana",
      "Lietotāja kontrolēti dublējumi",
      "Pēc izvēles svītrkoda meklēšana produkta informācijai.",
      "Ar reklāmām, izmantojot Google AdMob",
    ],
  },
  features: {
    heading: "Viss nepieciešamais",
    subheading:
      "Spēcīgas funkcijas vienkāršai un privātai produktu uzskaitei.",
    items: [
      {
        title: "Svītrkodu skeneris",
        description: "Ātra un precīza skenēšana jebkuram produktam.",
      },
      {
        title: "Produktu vērtējumi",
        description: "Novērtējiet ar 1–5 zvaigznēm, lai atcerētos kvalitāti.",
      },
      {
        title: "Produktu foto",
        description: "Pievienojiet foto iepakojumam vai detaļām.",
      },
      {
        title: "Kategorijas",
        description: "Organizējiet produktus savās kategorijās.",
      },
      {
        title: "Veikala uzskaite",
        description: "Atcerieties, kur katru preci nopirkāt.",
      },
      {
        title: "Cenu žurnāls",
        description: "Sekojiet cenām un atrodiet labākās.",
      },
      {
        title: "Iepirkumu saraksti",
        description: "Veidojiet sarakstus no iecienītākajiem produktiem.",
      },
      {
        title: "Bezsaistes piekļuve",
        description: "Perfekti darbojas bez interneta.",
      },
      {
        title: "Lokālā krātuve",
        description: "Visi dati droši glabājas jūsu ierīcē.",
      },
    ],
  },
  useCases: {
    heading: "Katram veikala nodalījumam",
    subheading:
      "Ēdiens, skaistumkopšana vai mājsaimniecība — WasOK palīdz atcerēties.",
    cards: [
      {
        emoji: "🍫",
        title: "Našķi un saldumi",
        description: "Atcerieties, kuri konfekšu veidi tiešām bija labi.",
      },
      {
        emoji: "☕",
        title: "Kafija un dzērieni",
        description: "Atzīmējiet kafiju, ko ir vērts pirkt atkārtoti.",
      },
      {
        emoji: "💄",
        title: "Kosmētika un kopšana",
        description: "Piezīmes par ādas reakcijām.",
      },
      {
        emoji: "🧹",
        title: "Sadzīves preces",
        description: "Nepērkiet atkārtoti to, kas neattaisnojās.",
      },
    ],
  },
  screenshots: {
    heading: "Skaisti un intuitīvi",
    subheading:
      "Pārdomāta saskarne, kas padara uzskaiti patīkamu.",
    items: [
      { title: "Skeneris" },
      { title: "Produkta detaļas" },
      { title: "Vērtējums" },
      { title: "Meklēšana un vēsture" },
      { title: "Iepirkumu saraksts" },
    ],
  },
  cta: {
    heading: "Iepirkumu atmiņa īstajai dzīvei.",
    body: "Pārtrauciet aizmirst, ko bija vērts pirkt. Sāciet gudrāk iepirkties jau šodien.",
    googlePlay: "Lejupielādēt Google Play",
    scanQr: "Skenējiet, lai lejupielādētu",
    tagline: "Privāti · Bezsaistes · Vienkārši",
  },
  footer: {
    tagline: "Atcerieties, ko bija vērts pirkt.",
    linksHeading: "Saites",
    privacyPolicy: "Privātuma politika",
    terms: "Pakalpojumu noteikumi",
    contact: "Kontakti",
    linkFaq: "BUJ",
    linkLicenses: "Atvērtā koda licences",
    linkAdvertising: "Reklāma un monetizācija",
    downloadHeading: "Lejupielāde",
    googlePlay: "Google Play",
    copyright:
      "© 2026 WasOK. Visas tiesības aizsargātas. Veidots ar 💚 gudrākiem iepirkumiem.",
  },
  legal: legalMessagesLv,
  faq: pagesMessagesLv.faq,
  support: pagesMessagesLv.support,
  advertising: pagesMessagesLv.advertising,
} satisfies Messages;
